import { render, staticRenderFns } from "./Fedex.vue?vue&type=template&id=78a23f2e&"
import script from "./Fedex.vue?vue&type=script&lang=js&"
export * from "./Fedex.vue?vue&type=script&lang=js&"
import style0 from "./Fedex.vue?vue&type=style&index=0&id=78a23f2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports